import { useCallback, useMemo } from "react";

import { useTracker } from "../../hooks/useTracker";
import { SubscriptionType } from "../../types";
import InfoTooltip from "../InfoTooltip/InfoTooltip";

export interface AutoRenewTooltipProps {
  type: SubscriptionType;
  expirationDate: Date;
  isAutoRenewEnabled: boolean;
}

const AutoRenewTooltip = ({ type, expirationDate, isAutoRenewEnabled }: AutoRenewTooltipProps) => {
  const tracker = useTracker();

  const trackAutoRenewalTooltipOpened = useCallback(
    () => tracker.trackAutoRenewalTooltipOpened(),
    [tracker]
  );

  const formattedLatestCancelDate = useMemo(() => {
    const latestCancelDate = new Date(expirationDate);
    latestCancelDate.setDate(latestCancelDate.getDate() - 1);

    return latestCancelDate.toLocaleString("en-us", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }, [expirationDate]);

  const shouldDisplayTooltip =
    (type === SubscriptionType.AppStore || type === SubscriptionType.Paddle) && isAutoRenewEnabled;

  if (!shouldDisplayTooltip) {
    return null;
  }

  return (
    <InfoTooltip
      content={
        <div data-testid="info-tooltip">
          If you&apos;d like to cancel your subscription, please do it by{" "}
          <strong>{formattedLatestCancelDate}</strong> latest to avoid being charged. <br /> Once
          you turn auto-renewal off, you&apos;ll still have Pro perks until the expiration date.
        </div>
      }
      trackTooltipOpened={trackAutoRenewalTooltipOpened}
    />
  );
};

export default AutoRenewTooltip;
